module.exports = __webpack_public_path__ + "static/media/faq.efd266cb.svg";